//========== Skills Section Component ==========

// import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import skills from "../../js/skillsData";
import responsive from "../../js/responsiveCarousel";
import "./skills.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Skills = () => {
  return /*#__PURE__*/_jsx("section", {
    className: "skill pt-5",
    id: "skills",
    children: /*#__PURE__*/_jsx("div", {
      className: "container",
      children: /*#__PURE__*/_jsx("div", {
        className: "row",
        children: /*#__PURE__*/_jsxs("div", {
          className: "col-12",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "skillContents",
            children: [/*#__PURE__*/_jsxs("h2", {
              className: "heading",
              children: [/*#__PURE__*/_jsx("i", {
                className: "fas fa-laptop-code"
              }), " Skills &", " ", /*#__PURE__*/_jsx("span", {
                className: "abilitiesSpan",
                children: "Abilities"
              })]
            }), /*#__PURE__*/_jsx("p", {
              children: "Explore my diverse skill set spanning various programming languages, frameworks, and tools. From web development to database management, my technical skills are designed to deliver robust and innovative solutions."
            })]
          }), /*#__PURE__*/_jsx(Carousel, {
            responsive: responsive,
            infinite: true,
            autoPlay: true,
            autoPlaySpeed: 2000,
            className: "skill-slider skill-bx",
            children: skills.map(skill => /*#__PURE__*/_jsxs("div", {
              className: "item",
              children: [/*#__PURE__*/_jsx("img", {
                src: skill.img,
                alt: skill.title
              }), /*#__PURE__*/_jsx("h5", {
                children: skill.title
              })]
            }, skill.title))
          })]
        })
      })
    })
  });
};
export default Skills;